export default ".auth-page {\n  transition: all 0.2s cubic-bezier(0.35, 0, 0.25, 1);\n}";